import React from 'react'
import useSWR from 'swr'
import type { YouTube } from '@/components/youtube/types'
import { LoadingSpinner } from '@/components/youtube/LoadingSpinner'
import { VideoCard } from '@/components/youtube/VideoCard'

const postChannelIds = async (ids: string[], path: string) => {
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ids }),
  })

  if (!response.ok) {
    //const more = response.Errors && response.Errors[0] && response.Errors[0].message ? response.Errors[0].message : ''
    throw new Error('Failed to post channel IDs') // + more)
  }

  // Return the response data if needed
  const data = await response.json()
  return data
}

export const VideoCards: React.FC<{ ids: string[]; apiUrl: string }> = ({ ids, apiUrl }) => {
  const {
    data: respone = {},
    error,
    isLoading,
  } = useSWR<YouTube>(apiUrl + ids.join(','), () => postChannelIds(ids, apiUrl + '/youtube/content'))

  const { videos = [] } = respone

  let c = 0

  const sortedData = [...videos].sort(function (a, b) {
    c++
    const dateA = new Date(a.snippet.publishedAt)
    const dateB = new Date(b.snippet.publishedAt)
    return dateB.getTime() - dateA.getTime()
  })

  console.log('after sorting:', { videos, sortedData })

  return !videos ? (
    <div>
      {error && error.message && <div>Error loading VideoCards message:{error.message}</div>}
      <LoadingSpinner /> VideoCards...
    </div>
  ) : (
    <div>
      {error && error.message && <div>Error loading VideoCards message:{error.message}</div>}
      <div className="p-2">
        {sortedData.length} videos {isLoading && <LoadingSpinner />}
      </div>

      <div className="p-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1">
        {sortedData.map((content, i) => {
          return <VideoCard key={i} content={content} />
        })}
      </div>
    </div>
  )
}
